export default "__VITE_ASSET__C9rz0Jzt__"